import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    vesselName: ""
}

const seempSlice = createSlice({
    name: "seemp",
    initialState,
    reducers: {
        setVesselRevisionDetails: (state, actions) => {
            state.vesselName = actions.payload.vesselName;
        }
    }
});

export const { setVesselRevisionDetails } = seempSlice.actions;

export default seempSlice.reducer;